import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ['password', 'lengthCheck', 'lowercaseCheck', 'uppercaseCheck', 'specialCheck', 'icon'];
  }

  // "satisfied"/"unsatisfied" are this controller's own names (edit_password_controller.js's
  // isPasswordValid reads them back off this same markup - see the comment there) and mount on 9
  // views via shared/lasso/_password_field_with_requirements.html.haml, so they get the Classes
  // API. "icon-lasso-show"/"icon-lasso-hide" are skipped: they're the app-wide icon glyph system
  // (lasso/v2/core/icons.scss), reused verbatim by edit_password_controller.js and
  // sign_in_controller.js and dozens of unrelated views - the same shared-utility shape as D1's
  // `hidden`, not a name this controller owns.
  static get classes() {
    return ["satisfied", "unsatisfied"]
  }

  get satisfiedClassName() {
    return this.hasSatisfiedClass ? this.satisfiedClass : "satisfied"
  }

  get unsatisfiedClassName() {
    return this.hasUnsatisfiedClass ? this.unsatisfiedClass : "unsatisfied"
  }

  checkPasswordRequirements() {
    const password = this.passwordTarget.value
    const checkClass = this.satisfiedClassName
    const uncheckedClass = this.unsatisfiedClassName

    if (this.verifyLength(password)) {
      this.lengthCheckTarget.classList.add(checkClass)
      this.lengthCheckTarget.classList.remove(uncheckedClass)
    } else {
      this.lengthCheckTarget.classList.remove(checkClass)
      this.lengthCheckTarget.classList.add(uncheckedClass)
    }

    if (this.verifyLowercase(password)) {
      this.lowercaseCheckTarget.classList.add(checkClass)
      this.lowercaseCheckTarget.classList.remove(uncheckedClass)
    } else {
      this.lowercaseCheckTarget.classList.remove(checkClass)
      this.lowercaseCheckTarget.classList.add(uncheckedClass)
    }

    if (this.verifyUppercase(password)) {
      this.uppercaseCheckTarget.classList.add(checkClass)
      this.uppercaseCheckTarget.classList.remove(uncheckedClass)
    } else {
      this.uppercaseCheckTarget.classList.remove(checkClass)
      this.uppercaseCheckTarget.classList.add(uncheckedClass)
    }

    if (this.verifySpecial(password)) {
      this.specialCheckTarget.classList.add(checkClass)
      this.specialCheckTarget.classList.remove(uncheckedClass)
    } else {
      this.specialCheckTarget.classList.remove(checkClass)
      this.specialCheckTarget.classList.add(uncheckedClass)
    }
  }

  togglePasswordVisibility() {
    if (this.passwordTarget.type === "password") {
      this.passwordTarget.type = "text";
      this.iconTarget.classList.remove('icon-lasso-show');
      this.iconTarget.classList.add('icon-lasso-hide');
    } else {
      this.passwordTarget.type = "password";
      this.iconTarget.classList.remove('icon-lasso-hide');
      this.iconTarget.classList.add('icon-lasso-show');
    }
  }

  verifyLength(password) {
    if (password.length >= 10) {
      return true
    }
    return false
  }

  verifyLowercase(password) {
    if (password.match(/[a-z]/)) {
      return true
    }
    return false
  }

  verifyUppercase(password) {
    if (password.match(/[A-Z]/)) {
      return true
    }
    return false
  }

  verifySpecial(password) {
    if (password.match(/[\d\W_]/)) {
      return true
    }
    return false
  }
}
